<div class="itineraries__gl-form">
  <lms-dynamic-form
    #itineraryForm
    [action]="itinerary ? 'training.itineraries.edit' : 'training.itineraries.create'"
    [options]="{
      submitLabel: itinerary
        ? itinerary.publish && itinerary.publish.active
          ? 'actions.publishChanges'
          : 'actions.saveChanges'
        : 'actions.createItinerary',
      disableCard: canEditItinerary,
      hideSubmit: !(clientView || canEditItinerary)
    }"
    [containerClass]="'large'"
    [questions]="questions"
    (submit)="submit($event)"
  >
    <ng-content select="[form-actions-before]" form-actions-before></ng-content>

    <ng-container *lmsProfileGuard="'training.itineraries.edit'" form-actions-before>
      <gl-button
        *ngIf="itinerary && canEditItinerary && itinerary.publish && !itinerary.publish.active"
        color-secondary
        [text]="'actions.publish' | translate"
        (onClick)="modalItineraryPublish.open()"
        [disabled]="!itineraryForm.submitDisabled"
      ></gl-button>
    </ng-container>
  </lms-dynamic-form>
</div>

<lms-itinerary-publish-modal
  #modalItineraryPublish
  [itinerary]="itinerary"
  (publish)="onPublish($event)"
></lms-itinerary-publish-modal>
